import { z } from "zod";

/** Optional org/specialty pins for study clinician QR invites (empty string clears). */
export const studyInviteSearchSchema = z.object({
    organisation_id: z.string().optional(),
    organisation_name: z.string().optional(),
    specialty: z.string().optional(),
});

export type StudyInviteSearchT = z.infer<typeof studyInviteSearchSchema>;
